import { EllipsisTextWithTooltip, Tooltip } from '@shape-ds/components';
import Status from 'components/Status/Status';
import { useFeatureFlag } from '@shape/feature-flag';
import { SapNoteCriticalLevel } from 'queries/externalReferences/contract';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

type SapNoteStatusProps = {
  status?: SapNoteCriticalLevel;
  code?: string;
  tooltipOnStatus?: { title: string };
  showCode?: boolean;
};
export const sapNotesStatusMap = {
  'OPEN-CRITICAL': 'error',
  'OPEN-NON-CRITICAL': 'warning',
  CLOSED: 'success',
  NOT_FOUND: 'offline',
} as const;

export type SapKeys = keyof typeof sapNotesStatusMap;

export const sapNotesOrder: Record<SapKeys, number> = {
  'OPEN-CRITICAL': 3,
  'OPEN-NON-CRITICAL': 2,
  NOT_FOUND: 1,
  CLOSED: 0,
} as const;

const SapNoteStatus: React.FC<SapNoteStatusProps> = ({
  status,
  code,
  tooltipOnStatus,
  showCode = true,
}) => {
  const { t } = useTranslation();
  const mappedStatus = status ? sapNotesStatusMap[status] : sapNotesStatusMap.NOT_FOUND;
  const statusIcon = <Status status={mappedStatus} />;
  const hasSapNote = useFeatureFlag('sap-notes-status');

  return (
    <span className="note-status-wrapper" data-testid="sap-note-status">
      {hasSapNote && (
        <Tooltip
          followCursor={false}
          placement="top"
          className={`note-status-tooltip ${mappedStatus}`}
          title={tooltipOnStatus?.title}
          style={{ lineHeight: '16px', fontSize: '12px' }}
        >
          {statusIcon}
        </Tooltip>
      )}
      {showCode && (
        <EllipsisTextWithTooltip
          className="note-status-code"
          text={code ?? t('conditionDeviation:sap_note_status.not_informed')}
        />
      )}
    </span>
  );
};

export default SapNoteStatus;
